export function NoAuth() {
  this.getIdToken = function () {
    return '';
  };
}
